import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=ca9d75e8&scoped=true&"
import script from "./DocumentsTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d75e8",
  null
  
)

export default component.exports